
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/concierge/yacht/[slug]",
      function () {
        return require("private-next-pages/concierge/yacht/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/concierge/yacht/[slug]"])
      });
    }
  